<p-header>
    Provide a unique template name
</p-header>
<form #f="ngForm" [formGroup]="form">
    <input pInputText formControlName="TemplateName" [title]="form.controls['TemplateName']?.errors?.forbiddenName?.value || ''"/>
</form>
<ng-template #footer >
    <mat-dialog-actions>
        <p-toolbar>
            <button
                [disabled]="f.invalid"
                pButton
                class="p-button-success"
                label="Save"
                (click)="dialogRef.close(form)"
            ></button>
            <button
                pButton
                class="p-button-warning"
                cdkFocusInitial
                label="Cancel"
                (click)="dialogRef.close()"
            ></button>
        </p-toolbar>
    </mat-dialog-actions>
</ng-template>
